import { BaseOdataUrl } from '../../../configVariables';
import { FlightTeam } from '../../../model';
import { ODataResult } from '../../../model/odata';
import apiClient from '../../../utils/apiClient';

export const fetchDepartureBoardFlights = async (
    query?: string
): Promise<ODataResult<FlightTeam[]>> => {
    const url = `${BaseOdataUrl}/DBGroundTeamFlightTeams${query}`;
    const result = await apiClient.get<ODataResult<FlightTeam[]>>(url);
    return result.data;
};
